// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1zOyd","footer":"ModalFilter_footer__2Rv3Q"};